import InputField from "../../atoms/InputField";

const DatosDeFacturacion = () => {
    return (
        <>
            <InputField name="fac_razonSocial" label="Nombre o Razón Social (Opcional)" placeholder="Ej. Juan Pérez o Inmobiliaria XYZ S.A. de C.V." />
            <InputField name="fac_rfc" label="RFC (Opcional)" placeholder="Ej. PEGJ800101HDF" />
            <InputField name="fac_usoCFDI" label="Uso del CFDI (Opcional)" placeholder="Ej. G03 - Gastos en general" />
            <InputField name="fac_email" label="Correo electrónico para facturar (Opcional)" placeholder="Ej. cliente@email.com" />
        </>
    );
};

export default DatosDeFacturacion;
